import { render, staticRenderFns } from "./AgreementFrame.vue?vue&type=template&id=6b650062&"
import script from "./AgreementFrame.vue?vue&type=script&lang=js&"
export * from "./AgreementFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports